<template>
  <section id="pp-about" class="pp-section">
    <h2 class="pp-section__title">
      <i class="mdi mdi-text-box-outline" aria-hidden="true"></i> About
    </h2>
    <p class="pp-about__text">{{ summary }}</p>
  </section>
</template>

<script>
export default {
  name: 'PublicProfileAbout',
  props: {
    summary: { type: String, required: true },
  },
};
</script>
